import React from 'react';
import { Helmet } from 'react-helmet-async';
import './PrivacyPolicy.css';

const PrivacyPolicy = () => {
  return (
    <>
      <Helmet>
        <title>מדיניות פרטיות - Auto Cross</title>
        <meta name="description" content="מדיניות הפרטיות של Auto Cross - הגנה על המידע האישי שלכם" />
      </Helmet>
      
      <div className="privacy-page">
        <div className="container">
          <header>
            <h1>מדיניות פרטיות</h1>
            <p className="last-updated">עדכון אחרון: {new Date().toLocaleDateString('he-IL')}</p>
          </header>

          <main>
            <section aria-labelledby="intro-title">
              <h2 id="intro-title">מבוא</h2>
              <p>
                Auto Cross ("החברה", "אנחנו", "שלנו") מחויבת להגנה על פרטיותכם. 
                מדיניות פרטיות זו מסבירה כיצד אנו אוספים, משתמשים ומגנים על המידע האישי שלכם 
                בעת השימוש באתר שלנו ובשירותינו.
              </p>
            </section>

            <section aria-labelledby="info-collection-title">
              <h2 id="info-collection-title">איסוף מידע</h2>
              <h3>מידע שאתם מספקים לנו:</h3>
              <ul>
                <li>פרטים אישיים (שם, טלפון, אימייל, כתובת)</li>
                <li>מידע על העדפות רכב ודרישות מיוחדות</li>
                <li>מידע פיננסי לצורך מימון (בהסכמתכם)</li>
                <li>תכתובות ופניות שירות</li>
              </ul>

              <h3>מידע שנאסף אוטומטית:</h3>
              <ul>
                <li>כתובת IP ומיקום גיאוגרפי כללי</li>
                <li>סוג דפדפן ומערכת הפעלה</li>
                <li>דפים שביקרתם באתר וזמן הביקור</li>
                <li>עוגיות (Cookies) ומזהים דומים</li>
              </ul>
            </section>

            <section aria-labelledby="info-usage-title">
              <h2 id="info-usage-title">שימוש במידע</h2>
              <p>אנו משתמשים במידע שלכם למטרות הבאות:</p>
              <ul>
                <li>מתן שירותי יבוא ומכירת רכבים</li>
                <li>עיבוד הזמנות וניהול עסקאות</li>
                <li>מתן שירותי לקוחות ותמיכה</li>
                <li>שיפור השירותים והאתר</li>
                <li>שליחת עדכונים ומידע שיווקי (בהסכמתכם)</li>
                <li>עמידה בדרישות חוקיות ורגולטוריות</li>
              </ul>
            </section>

            <section aria-labelledby="info-sharing-title">
              <h2 id="info-sharing-title">שיתוף מידע</h2>
              <p>אנו עשויים לשתף את המידע שלכם עם:</p>
              <ul>
                <li><strong>ספקי שירות:</strong> חברות ביטוח, בנקים למימון, חברות שילוח</li>
                <li><strong>רשויות:</strong> כאשר נדרש על פי חוק או צו בית משפט</li>
                <li><strong>שותפים עסקיים:</strong> יבואנים ויצרני רכב (במידת הצורך)</li>
                <li><strong>חברות טכנולוגיה:</strong> לצורך תחזוקת האתר ושירותי ענן</li>
              </ul>
              <p><strong>אנו לא מוכרים את המידע האישי שלכם לצדדים שלישיים.</strong></p>
            </section>

            <section aria-labelledby="cookies-title">
              <h2 id="cookies-title">עוגיות (Cookies)</h2>
              <p>האתר שלנו משתמש בעוגיות למטרות הבאות:</p>
              <ul>
                <li><strong>עוגיות חיוניות:</strong> לתפעול בסיסי של האתר</li>
                <li><strong>עוגיות ביצועים:</strong> לניתוח שימוש ושיפור האתר</li>
                <li><strong>עוגיות שיווק:</strong> להצגת פרסומות רלוונטיות (בהסכמתכם)</li>
              </ul>
              <p>ניתן לנהל את העדפות העוגיות דרך הגדרות הדפדפן שלכם.</p>
            </section>

            <section aria-labelledby="data-security-title">
              <h2 id="data-security-title">אבטחת מידע</h2>
              <p>אנו נוקטים באמצעי אבטחה מתקדמים להגנה על המידע שלכם:</p>
              <ul>
                <li>הצפנת SSL לכל העברות הנתונים</li>
                <li>שרתים מאובטחים ומוגנים</li>
                <li>גישה מוגבלת למידע רק לעובדים מורשים</li>
                <li>גיבויים קבועים ותוכניות התאוששות</li>
                <li>עדכונים שוטפים של מערכות האבטחה</li>
              </ul>
            </section>

            <section aria-labelledby="user-rights-title">
              <h2 id="user-rights-title">זכויותיכם</h2>
              <p>על פי חוק הגנת הפרטיות, זכאים אתם ל:</p>
              <ul>
                <li><strong>עיון במידע:</strong> לדעת איזה מידע אנו שומרים עליכם</li>
                <li><strong>תיקון מידע:</strong> לבקש תיקון מידע שגוי או לא מדויק</li>
                <li><strong>מחיקת מידע:</strong> לבקש מחיקת המידע שלכם (בכפוף לחוק)</li>
                <li><strong>הגבלת עיבוד:</strong> לבקש הגבלה על השימוש במידע</li>
                <li><strong>ניידות מידע:</strong> לקבל את המידע שלכם בפורמט נגיש</li>
                <li><strong>התנגדות:</strong> להתנגד לעיבוד המידע למטרות שיווק</li>
              </ul>
            </section>

            <section aria-labelledby="data-retention-title">
              <h2 id="data-retention-title">שמירת מידע</h2>
              <p>
                אנו שומרים את המידע שלכם כל עוד זה נחוץ למתן השירותים או כפי שנדרש על פי חוק. 
                מידע של לקוחות פעילים נשמר למשך תקופת הקשר העסקי ועד 7 שנים לאחר מכן 
                לצרכים חשבונאיים וחוקיים.
              </p>
            </section>

            <section aria-labelledby="minors-title">
              <h2 id="minors-title">קטינים</h2>
              <p>
                השירותים שלנו מיועדים לבגירים בלבד. אנו לא אוספים במודע מידע אישי 
                מקטינים מתחת לגיל 18. אם הובא לידיעתנו שאספנו מידע כזה, נמחק אותו מיידית.
              </p>
            </section>

            <section aria-labelledby="changes-title">
              <h2 id="changes-title">שינויים במדיניות</h2>
              <p>
                אנו עשויים לעדכן מדיניות פרטיות זו מעת לעת. שינויים מהותיים יפורסמו 
                באתר עם הודעה מוקדמת של 30 יום. המשך השימוש באתר לאחר השינויים 
                מהווה הסכמה למדיניות המעודכנת.
              </p>
            </section>

            <section aria-labelledby="contact-title">
              <h2 id="contact-title">יצירת קשר</h2>
              <p>לשאלות או בקשות בנוגע לפרטיות, ניתן לפנות אלינו:</p>
              
              <div className="contact-info">
                <address>
                  <p>
                    <strong>קצין הגנת פרטיות:</strong><br />
                    Auto Cross<br />
                    התמר 3, אבן יהודה
                  </p>
                  <p>
                    <strong>טלפון:</strong> 
                    <a href="tel:03-3820232" aria-label="התקשר לטלפון 03-3820232">03-3820232</a>
                  </p>
                  <p>
                    <strong>אימייל:</strong> 
                    <a href="mailto:office@auto-cross.co.il" aria-label="שלח אימייל לקצין הגנת הפרטיות">office@auto-cross.co.il</a>
                  </p>
                </address>
              </div>
            </section>
          </main>
        </div>
      </div>
    </>
  );
};

export default PrivacyPolicy;
